import {
  isHlsMediaType,
  parseMediaTypeString
} from "./chunk-2UU3XUBN.js";

// node_modules/hls.js/src/utils/mediasource-helper.ts
function getMediaSource() {
  if (typeof self === "undefined")
    return void 0;
  return self.MediaSource || self.WebKitMediaSource;
}

// node_modules/hls.js/src/is-supported.ts
function getSourceBuffer() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function isSupported() {
  const mediaSource = getMediaSource();
  if (!mediaSource) {
    return false;
  }
  const sourceBuffer = getSourceBuffer();
  const isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === "function" && mediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
  const sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === "function" && typeof sourceBuffer.prototype.remove === "function";
  return !!isTypeSupported && !!sourceBufferValidAPI;
}

// src/adapter/hlsjs/can-play-type.ts
function canPlayType(mediaType) {
  const type = typeof mediaType === "string" ? parseMediaTypeString(mediaType) : mediaType;
  return !!type && isHlsMediaType(type) && isSupported();
}

export {
  canPlayType
};
